module.exports = __webpack_public_path__ + "img/logo.21e61fac.svg";